// popup-script.js
// Shopify-Compatible Notification Popup with Country Flags

(function () {
  console.log("Clarity Conscious Notification System Initialized");

  const peopleDatabase = [
    { name: "John", country: "United States", code: "US" },
    { name: "Raj", country: "India", code: "IN" },
    { name: "Emma", country: "United Kingdom", code: "GB" },
    { name: "Liu", country: "China", code: "CN" },
    { name: "Maria", country: "Brazil", code: "BR" },
    { name: "Hans", country: "Germany", code: "DE" },
    { name: "Sophie", country: "France", code: "FR" },
    { name: "Yuki", country: "Japan", code: "JP" },
    { name: "Carlos", country: "Mexico", code: "MX" },
    { name: "Anna", country: "Russia", code: "RU" },
    { name: "Ahmed", country: "Egypt", code: "EG" },
    { name: "Isabella", country: "Italy", code: "IT" },
    { name: "Jae", country: "South Korea", code: "KR" },
    { name: "Olivia", country: "Canada", code: "CA" },
    { name: "Mateo", country: "Spain", code: "ES" },
    { name: "Ava", country: "Australia", code: "AU" },
    { name: "Liam", country: "Ireland", code: "IE" },
    { name: "Zoe", country: "New Zealand", code: "NZ" },
    { name: "Thabo", country: "South Africa", code: "ZA" },
    { name: "Fatima", country: "Saudi Arabia", code: "SA" },
    { name: "Lars", country: "Sweden", code: "SE" },
    { name: "Nina", country: "Norway", code: "NO" },
    { name: "Sven", country: "Denmark", code: "DK" },
    { name: "Mei", country: "Singapore", code: "SG" },
    { name: "Hiroshi", country: "Japan", code: "JP" },
    { name: "Priya", country: "India", code: "IN" },
    { name: "Michael", country: "United States", code: "US" },
    { name: "Charlotte", country: "United Kingdom", code: "GB" },
    { name: "Pedro", country: "Brazil", code: "BR" },
    { name: "Thomas", country: "Germany", code: "DE" },
    { name: "Camille", country: "France", code: "FR" },
    { name: "Takashi", country: "Japan", code: "JP" },
    { name: "Elena", country: "Mexico", code: "MX" },
    { name: "Dmitri", country: "Russia", code: "RU" },
    { name: "Layla", country: "Egypt", code: "EG" },
    { name: "Marco", country: "Italy", code: "IT" },
    { name: "Min", country: "South Korea", code: "KR" },
    { name: "Sophia", country: "Canada", code: "CA" },
    { name: "Alejandro", country: "Spain", code: "ES" },
    { name: "Grace", country: "Australia", code: "AU" },
    { name: "Finn", country: "Ireland", code: "IE" },
    { name: "Amelia", country: "New Zealand", code: "NZ" },
    { name: "Mandla", country: "South Africa", code: "ZA" },
    { name: "Aisha", country: "Saudi Arabia", code: "SA" },
    { name: "Erik", country: "Sweden", code: "SE" },
    { name: "Ingrid", country: "Norway", code: "NO" },
    { name: "Magnus", country: "Denmark", code: "DK" },
    { name: "Lin", country: "Singapore", code: "SG" },
  ];

  const messageTemplates = [
    "{{name}} from {{country}} has joined Clarity Conscious to take control of their mind and life.",
    "{{name}} from {{country}} has joined Clarity Conscious to find clarity and real change.",
    "{{name}} from {{country}} has joined Clarity Conscious to improve their mental well-being.",
    "{{name}} from {{country}} has joined Clarity Conscious for personal growth and transformation.",
    "{{name}} from {{country}} is taking the first step toward a healthier mind with Clarity Conscious.",
    "{{name}} from {{country}} has joined Clarity Conscious to discover peace and purpose.",
    "{{name}} from {{country}} has started their journey to mental clarity with Clarity Conscious.",
    "{{name}} from {{country}} is embracing change through Clarity Conscious.",
    "{{name}} from {{country}} has joined Clarity Conscious to become the best version of themselves.",
    "{{name}} from {{country}} is taking control of their life with Clarity Conscious.",
    "{{name}} from {{country}} has joined Clarity Conscious to prioritize their mental health.",
    "{{name}} from {{country}} is seeking balance and growth through Clarity Conscious.",
    "{{name}} from {{country}} is investing in their mental wellness with Clarity Conscious.",
    "{{name}} from {{country}} has chosen a path of transformation with Clarity Conscious.",
    "{{name}} from {{country}} has taken the first step to a mindful life with Clarity Conscious.",
  ];

  function createPopupContainer() {
    if (document.getElementById("clarity-join-notification")) return;

    const popup = document.createElement("div");
    popup.id = "clarity-join-notification";
    popup.className = "clarity-notification-popup";
    popup.style.display = "none";

    document.body.appendChild(popup);

    const style = document.createElement("style");
    style.innerHTML = `
      .clarity-notification-popup {
        position: fixed;
        bottom: 20px;
        left: 20px;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 8px;
        padding: 12px 15px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        display: flex;
        align-items: center;
        max-width: 300px;
        opacity: 0;
        transform: translateY(100px);
        transition: opacity 0.5s ease, transform 0.5s ease;
        z-index: 9999;
      }
      .clarity-notification-popup.show {
        opacity: 1;
        transform: translateY(0);
      }
      .clarity-notification-popup .country-flag {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
        object-fit: cover;
        border: 1px solid #ccc;
      }
      .clarity-notification-popup .notification-text {
        font-size: 14px;
        color: #333;
      }
      @media (max-width: 767px) {
        .clarity-notification-popup {
          left: 10px;
          right: 10px;
          max-width: calc(100% - 20px);
        }
      }
    `;
    document.head.appendChild(style);
  }

  function showNotification(person) {
    const popup = document.getElementById("clarity-join-notification");
    if (!popup) return;

    const flagUrl = `https://flagcdn.com/48x36/${person.code.toLowerCase()}.png`;
    const message = messageTemplates[
      Math.floor(Math.random() * messageTemplates.length)
    ]
      .replace("{{name}}", person.name)
      .replace("{{country}}", person.country);

    popup.innerHTML = `
      <img src="${flagUrl}" alt="${person.country} flag" class="country-flag" />
      <div class="notification-text">${message}</div>
    `;

    popup.style.display = "flex";
    setTimeout(() => popup.classList.add("show"), 10);
    setTimeout(() => {
      popup.classList.remove("show");
      setTimeout(() => (popup.style.display = "none"), 500);
    }, 6000); // Show for 6 seconds instead of 5
  }

  function startLoop() {
    createPopupContainer();
    let index = 0;

    // First popup appears after 15 seconds (increased from 8)
    setTimeout(() => {
      showNotification(peopleDatabase[index]);
      index = (index + 1) % peopleDatabase.length;

      // Subsequent popups appear every 15 seconds (increased from 8)
      setInterval(() => {
        showNotification(peopleDatabase[index]);
        index = (index + 1) % peopleDatabase.length;
      }, 15000); // Changed from 8000 to 15000 (15 seconds)
    }, 15000); // Changed from 8000 to 15000 (15 seconds)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startLoop);
  } else {
    startLoop();
  }
})();